import DataModuleBaseUtils from './data-module-base-utils';

export default class AverageStudentEarningsUtils extends DataModuleBaseUtils {
  whole = ({totalStudents}) => {
    if (totalStudents < 5) {
      return 5;
    }

    return 120000;
  };

  value = ({rawValue, totalStudents}) => {
    if (totalStudents < 5) {
      return isNaN(parseInt(totalStudents)) ? 0 : totalStudents;
    }

    const value = rawValue || 0;

    return Math.round(value);
  };

  decoratedValue = ({value, totalStudents}) => {
    if (totalStudents < 5) {
      return value.toLocaleString();
    }

    return `$${value.toLocaleString()}`;
  };

  comparisonValue = ({districtAverage, totalStudents}) => {
    const defaultValue = 85000;

    if (totalStudents < 5) {
      return '5';
    }

    const value = districtAverage ? districtAverage : defaultValue;

    return `$${Math.round(value).toLocaleString()}`;
  };

  headerCopy = ({totalStudents}) => {
    if (totalStudents < 5) {
      return 'Students Earning on Raise Me';
    }

    return 'Average Student Earnings';
  };

  headerLinkCopy = ({totalStudents}) => {
    if (totalStudents < 5) {
      return 'Invite Students';
    }

    return 'View Available Scholarships';
  };

  bodyHeader = ({totalStudents}) => {
    if (totalStudents < 5) {
      return this.emptyStateBodyHeader();
    }

    return '50% of schools average more than $30,000';
  };

  bodyContent = ({totalStudents}) => {
    if (totalStudents < 5) {
      return this.emptyStateBodyContent();
    }

    return 'Students can increase earnings by adding classes and activities to their Portfolios.';
  };

  surveyLocalStorageKey = () => 'Survey::DataModules:AverageStudentEarnings';
}
